import { render, staticRenderFns } from "./infoAnchor.vue?vue&type=template&id=a657f6c6&scoped=true&"
import script from "./infoAnchor.vue?vue&type=script&lang=js&"
export * from "./infoAnchor.vue?vue&type=script&lang=js&"
import style0 from "./infoAnchor.vue?vue&type=style&index=0&id=a657f6c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a657f6c6",
  null
  
)

export default component.exports